// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true, // make it true when releasing dev  build need for the appCheck
  environment: 'dev',
  appName: 'TRS-connect-dev',
  firebase: {
    apiKey: 'AIzaSyDXUW5nPZ48Q5eFQAWrfU3lclr97qSNRto',
    authDomain: 'trsconnect-dev-779bb.firebaseapp.com',
    projectId: 'trsconnect-dev-779bb',
    storageBucket: 'trsconnect-dev-779bb.firebasestorage.app',
    messagingSenderId: '66437823901',
    appId: '1:66437823901:web:5710a867ffd220b2d4c374',
    measurementId: 'G-87VXNG7KRB',
  },
  recaptchaSiteKey: '6LfPyjUtAAAAAOY5qzvWiIJb80d3c6mYxyJWfL8A',
  functions: {
    storageDownload: 'https://europe-west1-trsconnect-dev-779bb.cloudfunctions.net/downloadJsonFile',
    provisionWrappedS: 'https://europe-west1-trsconnect-dev-779bb.cloudfunctions.net/provisionWrappedS',
  },
  hostUrl: 'https://trs-dev.caterpillar.com/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
